<template>
  <div class="grade-praise">
    <div class="select">
      <div class="select-node" @click="showPicker = true">
          期日：{{currentTime}}
      </div>
      <popup v-model="showPicker" round position="bottom" :style="{ height: '40%', width: '100%' }">
        <datetime-picker
          type="date"
          title="时间"
          v-model="currentDate"
          :columns-order="['year', 'month', 'day']"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="showPicker = false"
          @confirm="onInput"
          :formatter="formatter"
          />
      </popup>
      <!-- <div class="select-node" @click="showPicker = true">
        期日：{{weekValue}}
      </div>
      <popup v-model="showPicker" round position="bottom">
        <picker
          :columns="weekSelect"
          show-toolbar
          @cancel="showPicker = false"
          @confirm="onConfirm"
          :default-index="todayIndex"
        />
      </popup>
      <div class="select-node" @click="showPicker2Func">
        筛选：<div class="lesson-box-name">{{lessonName}}</div>&nbsp;,&nbsp;<div>{{teacherchName}}</div> 
      </div>
      <popup v-model="showPicker2" :style="{ width: '80%', height: '100%'}"  position="right">
        <div class="select-content">          
          <div class="select-name">
            筛选
          </div>
          <field
            readonly
            is-link
            @click="showPicker3 = true"
            label="老师"
            :style="{ borderBottom: 'solid 1px #f9f9f9'}"
          />
          <popup v-model="showPicker3" :style="{ width: '100%', height: '100%'}"  position="right">
            <div class="select-name postion">
              <icon name="arrow-left" class="icon-back" @click="showPicker2Func"/> 
              <div>
                筛选
              </div>
            </div>
            <div class="content-box">
              <div v-for="(item, index) in teacherSelect" @click="teacherSeleClick(item, item.id)" :key="index" class="item-name" :style="{color: !index ?'#a7afbd' : 'black'}">
                {{ item.name }}
              </div>
            </div>
          </popup>
          <field
            readonly
            is-link
            @click="showPicker4 = true"
            label="班级"
            :style="{ borderBottom: 'solid 1px #f9f9f9'}"
          />   
          <popup v-model="showPicker4" :style="{ width: '100%', height: '100%'}"  position="right">
            <div class="select-name postion">
              <icon name="arrow-left" class="icon-back" @click="showPicker2Func"/> 
              <div>
                筛选
              </div>
            </div>
            <div class="content-box">
              <div v-for="(item, index) in lessonSelect" @click="gradeSeleClick(item, item.id)" :key="index" class="item-name" :style="{color: !index ?'#a7afbd' : 'black'}">
                {{ item.name }}
              </div>
            </div>
          </popup>     
        </div>
      </popup> -->
    </div>
    <div class="lesson-box" ref="wrapper">
      <div class="lesson-box-content">
        <div v-for="(item, index) in lessonList" :key="index">
          <div class="lesson-item-box">
            <div class="time-today"> {{ item.timeStr }} </div>
            <div v-for="(item_min, index_min) in item.list" :key="index_min" class="lesson-item" 
                 @click="goView('/grade/commentPraiseInfo',{ lessonId: item_min.id, teacherId: item_min.teacherId })" >
              <div class="left">
                <div class="lesson-name-time">
                  {{ item_min.gradeName }} {{ item_min.timeStart }}
                </div>
                <div class="lesson-time-teacher">
                  <div class="lesson-times"> {{ item_min.timeStart }}-{{ item_min.timeStop }} </div>
                  <div class="lesson-teachername"> {{ item_min.teacher }} </div>
                </div>            
              </div>
              <div class="right">
                <div class="state-count">已评 {{ item_min.one }} </div> | <div class="state-count">应评 {{ item_min.zero }} </div>
              </div>
            </div>
          </div>
        </div>        
        <div class="foot-message"> {{ dataEnd ? (lessonList.length ? '数据已全部加载完毕' : '没有数据') : '' }} </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { gradeLessonTime } from "@api/user";
// import { gradeLesson } from "@api/store";
import { leaveamessagesel, lessonSListSelect } from "@api/grade";
import { teachersList } from "@api/public";
import { Picker, Field, Popup, Icon, DatetimePicker } from "vant"
import { addZoo } from '@common'

import BScroll from 'better-scroll'

export default {
  name: "GradePraise",
  components: {
    Picker,
    Field,
    Popup,
    Icon,
    DatetimePicker
  },
  data: function() {
    return {
      lessonList: [],
      weekValue: '全部',
      showPicker: false,
      weekSelect: ['全部','周一','周二','周三','周四','周五','周六','周日'],
      weekLessonList: [],
      weekLessonListSort: [],
      toDay: new Date().getDay(),
      teacherchName: '全部',
      lessonName: '全部',
      showPicker2: false,
      todayIndex: !(new Date().getDay()) ? 7 : (new Date().getDay()),
      weekIndex: 0,
      weekof: 1,
      teacherId: 0,
      gradeId: 0,
      teacherSelect: [
        {
          name: '全部',
          id: 0
        },
      ],
      lessonSelect: [
        {
          name: '全部',
          id: 0
        }
      ],
      lessonListStore: [],
      showPicker3: false,
      showPicker4: false,
      path: '/class/student',
      zero: 0,
      needweekAdd: -1,
      currentTime: '全部',
      page: 1, 
      limit: 15,
      dataEnd: false,
      selectState: false, //选择筛选
      currentDate: new Date(),
      minDate: new Date(2019, 0, 1),
      maxDate: new Date(),
      scroll: null
    };
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      return val;
    },
    getGradeList(func) {
      let data = {
        page: this.page,
        limit: this.limit,
      }
      if (this.dataEnd) {
        return null;
      }
      leaveamessagesel(data).then(res => {
        let result = res.data.information;
        if (!result.length) { //数据空
          return this.dataEnd = true;
        }

        func(result);          
      })
    },
    // getLessonList() { //获取班级列表
    //   gradeLesson().then(res => {
    //     let result = res.data.list;
    //     let lessonSelect = this.lessonSelect;
    //     let lessonSelectStore = [];
    //     for (let item of result) {
    //       lessonSelectStore.push({
    //         id: item.id,
    //         name: item.grade
    //       })
    //     }
        
    //     this.lessonSelect = Object.assign(lessonSelect.concat(lessonSelectStore),[]);
    //   })
    // },
    getTeachers() { //获取教师列表
      teachersList().then(res => {
        let result = res.data.list;
        let teacherSelect = this.teacherSelect;
        let teacherSelectStore = [];
        for (let item of result) {
          teacherSelectStore.push({
            id: item.id,
            name: item.staff_name
          })
        }
        this.teacherSelect = Object.assign(teacherSelect.concat(teacherSelectStore), []);
      })
    },
    onConfirm(value, index) { //筛选周    const { value, index } = event.detail;
      this.showPicker = false;
      if (this.weekof === true << ~(this.needweekAdd << 2) << 1 << 1) { //周的筛选次数条件充足
        this.weekValue = value;
        this.weekIndex = index;
        this.lessonList = this.selectList();
        return null >>> 0;
      }else if(this.weekof && this.needweekAdd) {
        this.weekValue = value;
        this.weekIndex = index;
        this.lessonList = this.selectList(index, this.teacherId, this.gradeId);        
      }
      if (!index) {
        this.weekof <<= true;
      }else {
        this.weekof = ~this.zero & true;
      }

    },
    showPicker2Func() {
      this.showPicker2 = true;
      this.showPicker3 = false;
      this.showPicker4 = false;
    },
    // teacherSeleClick(item, id) { //筛选教师
    //   this.showPicker2Func();
    //   if (this.weekof === true << ~(this.needweekAdd << 2) << 1 << 1) { //周的筛选次数条件充足
    //     this.teacherchName = Object.assign(item).name;
    //     this.teacherId = id;
    //     this.lessonList = this.selectList();
    //     return null >>> this.zero;
    //   }else if(this.weekof && this.needweekAdd) {
    //     this.teacherchName = item.name; //选择
    //     this.teacherId = id;
    //     this.lessonList = this.selectList(this.weekIndex, id, this.gradeId);
    //   }
    //   if (!id) {
    //     this.weekof <<= true;
    //   }else {
    //     this.weekof = ~this.zero & true;
    //   }
    // },
    // gradeSeleClick(item, id) { //班级筛选
    //   this.showPicker2Func();
    //   if (this.weekof === true << ~(this.needweekAdd << 2) << 1 << 1) { //周的筛选次数条件充足
    //     this.lessonName = Object.assign(item).name;
    //     this.gradeId = id;
    //     this.lessonList = this.selectList();
    //     return null >>> this.zero;
    //   }else if(this.weekof && this.needweekAdd) {
    //     this.lessonName = item.name;
    //     this.gradeId = id;
    //     this.lessonList = this.selectList(this.weekIndex, this.teacherId, id);        
    //   }
    //   if (!id) {
    //     this.weekof <<= true;
    //   }else {
    //     this.weekof = ~this.zero & true;
    //   }

    // },
    // /**
    //  * weekIndex：周index, teacherId：老师id, gradeId：班级id
    //  */
    // selectList(weekIndex, teacherId, gradeId) { 
    //   let selectData = [];
    //   if (this.weekLessonList[0] && this.weekLessonListSort[0]) {
    //     if (weekIndex === (3|5)) {
    //       selectData = Object.assign(this.weekLessonList[0],[]);    
    //     }else if (weekIndex){
    //       selectData = Object.assign(this.weekLessonList[weekIndex],[]);       
    //     }else if (!weekIndex) {
    //       selectData = Object.assign(this.weekLessonListSort,[]);
    //     }

    //     if (teacherId) {
    //       selectData = selectData.filter(item => item.teacherId === teacherId);
    //     }

    //     if (gradeId) {
    //       selectData = selectData.filter(item => item.gradeId === gradeId);
    //     }

    //     return selectData;
    //   }
    // },
    arraySort(result) {
      let arr = []
      for (let item of result) {
        let index = arr.findIndex(element => element.time === item.signintime);
        if (index === -1) {
          arr.push({ time: item.signintime, 
            timeStr: `${new Date(Number(item.signintime+'000')).getFullYear()}-${addZoo(new Date(Number(item.signintime+'000')).getMonth()+1)}-${addZoo(new Date(Number(item.signintime+'000')).getDate())}`,
            list: [{
              gradeName: item.lesson,
              gradeId: item.grade_id,
              id: item.lesson_id,
              teacher: item.staff_name,
              teacherId: item.teacher_id,
              timeStart: item.start_time,
              timeStop: item.stop_time, 
              zero: item.zero,
              one: item.one
            }]});
        }else {
          arr[index].list.push({
            gradeName: item.lesson,
            gradeId: item.grade_id,
            id: item.lesson_id,
            teacher: item.staff_name,
            teacherId: item.teacher_id,
            timeStart: item.start_time,
            timeStop: item.stop_time, 
            zero: item.zero,
            one: item.one
          })
        }
      }
      return arr;
    },
    goView(path, params) {
      if (params) {
        this.$router.push({
          path,
          query: params
        });
      }else {
        this.$router.push(path);
      }
    },
    firstStoreData(data) {
      this.lessonListStore = data;
      this.lessonList = this.arraySort(data);
      this.scroll.finishPullUp();
    },
    listDataPush(data) {
      let lessonListStore = Object.assign(this.lessonListStore,[]);
      lessonListStore.push(...data);
      this.lessonListStore = lessonListStore;
      this.lessonList = this.arraySort(lessonListStore);
      this.scroll.finishPullUp();
    },
    timeSlectgetGradeList(time, func) {
      this.scroll.refresh();
      this.scroll.scrollTo(0,0,0);
      if (time) {
        let timeStr = String(time);
        lessonSListSelect({ signintime: timeStr.slice(0, timeStr.length-3) }).then(res => {
          let result = res.data.information;
          func(result); 
        }).finally(() => {
          this.dataEnd = true;
        })
      }
    },
    onInput(time) {
      let d = new Date(time);
      let timeDate = {
        year: d.getFullYear(),
        month: d.getMonth(),
        day: d.getDate()
      }
      this.timeSlectgetGradeList(new Date(...Object.values(timeDate)).getTime(), this.firstStoreData);
      this.showPicker = false;
      this.currentDate = time;
      this.thiscurrentTime = `${timeDate.year}-${addZoo(timeDate.month+1)}-${addZoo(timeDate.day)}`;
      if (!this.selectState) {
        this.selectState = true
      }
    },
  },
  mounted() {
    // this.getGradeLseeon();
    // this.getLessonList();
    // this.getTeachers();
    this.getGradeList(this.firstStoreData);
    this.scroll = new BScroll(this.$refs.wrapper, {
      pullUpLoad: true,
      click: true,
      threshold: 30,
      bounceTime: 1000
    })
    this.scroll.on('pullingUp', () => {
      this.scroll.refresh();
      if (!this.selectState) {
        this.page += 1;
        this.getGradeList(this.listDataPush);
      }
    })
  }
};
</script>

<style scoped>
  .grade-praise {
    height: 100vh;
    width: 100vw;
    background-color: white;
    position: relative;
  }
.select {
  display: flex;
  background-color: white;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #fbf4ff;
  height: 40px;
  width: 100vw;
}
.select-node {
  background-color: white;
  padding: 0 15px;
  display: flex;
  min-width: 130px;
}
.select-right {
  min-width: 190px;
  justify-content: flex-end;
}
.postion {
  position: relative;
}
  .content-box {
    height: calc(100% - 55px);
    overflow-y: scroll;
    padding: 0 15px;
  }
    .item-name {
      border-bottom: 1px solid rgb(249, 249, 249);
      color: black;
      padding: 5px;
    }
  .select-name {
    text-align: center;
    margin: 20px 0 10px;
    font-size: 16px;
    height: 25px;
  }
    .lesson-box-name {
      max-width: 48%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 10px;

    }
    .lesson-teacher-name {
      max-width: 30%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 10px;
    }
    .icon-back {
      position: absolute;
      left: 10px;
      bottom: 5px;
    }
  .lesson-box {
    height: calc(100% - 40px);
    overflow-y: scroll;
  }
  .lesson-box::-webkit-scrollbar {
   display: none;
  }
    .lesson-box-content {
      padding: 0 10px 30px;
    }
      .lesson-item {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid rgb(243, 243, 255);
        padding: 20px 10px ;
      }
      /* .lesson-item-box {
        border-bottom: 1px solid #e5daf1;
      } */
      .time-today {
        padding: 20px 10px 0;
        font-size: 16px;
        color: #9a9a9a;
      }
        .left {
          font-size: 16px;
        }
          .lesson-name-time {
            font-size: 16px;
            font-weight: 550;
          }
          .lesson-time-teacher {
            display: flex;
            color: #7d7d7d;
          }
            .lesson-times {
              margin-right: 10px;
            }
        .right {
          display: flex;
          font-size: 14px;
          color: #7d7c7a;
          display: flex;
          align-items: center;
        }
          .state-count {
            padding: 0 7px;
          }
    .foot-message {
      padding: 20px 0 50px;
      text-align: center;
      letter-spacing: 1px;
      font-size: 17px;
    }
</style>